import {Pipe, PipeTransform} from '@angular/core';

/**
 * Swaps an icon asset path for its LUX_ENGINE-colored "-lux" sibling file
 * (e.g. assets/icons/jobs/album.svg -> assets/lux-engine/album-lux.svg) when
 * the authenticated member's userType is LUX_ENGINE. Used for standalone SVG
 * icon assets whose fill color is baked into the file and can't be reached
 * via CSS (see AuthenticationService.isLuxEngine$).
 *
 * All "-lux" variant files live flattened in one folder (src/assets/lux-engine)
 * regardless of which icons/ subfolder the original came from, so this only
 * needs the original's filename, not its directory.
 */
@Pipe({
    name: 'themedIcon'
})
export class ThemedIconPipe implements PipeTransform {

    transform(path: string, isLuxEngine: boolean): string {
        if (!isLuxEngine || !path) {
            return path;
        }
        const match = path.match(/^(.*\/)?([^\/]+)\.svg$/i);
        if (!match) {
            return path;
        }
        const [, dirPart, baseName] = match;
        const luxDir = (dirPart || '').replace(/assets\/.*$/, 'assets/lux-engine/');
        return `${luxDir}${baseName}-lux.svg`;
    }

}
